import { render } from "./FillablePdfForm.vue?vue&type=template&id=48d34f5a&scoped=true"
import script from "./FillablePdfForm.vue?vue&type=script&lang=js"
export * from "./FillablePdfForm.vue?vue&type=script&lang=js"

import "./FillablePdfForm.vue?vue&type=style&index=0&id=48d34f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d34f5a"]])

export default __exports__